import { render, staticRenderFns } from "./model1.vue?vue&type=template&id=f2625884"
import script from "./model1.vue?vue&type=script&lang=js"
export * from "./model1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports